import { ChangeEvent } from 'react'
import cx from 'classnames'

import { SelectValue } from '../BaseSelect'

import CheckboxComponent from './Checkbox'

type CheckboxGroupOption = SelectValue & {
  isChecked?: boolean
  isDisabled?: boolean
}

export type CheckboxGroupProps = {
  options: CheckboxGroupOption[]
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const CheckboxGroup = ({ options, onChange }: CheckboxGroupProps) => {
  const isSingleOption = options.length === 1

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option: CheckboxGroupOption) => (
        <div
          key={option.value}
          className={cx('border border-coolGray-300', {
            'mr-2': !isSingleOption,
            'bg-maroon-40 border-maroon-400': option.isChecked,
            'hover:bg-maroon-40 hover:border-maroon-200': !option.isDisabled,
            'bg-coolGray-50 cursor-not-allowed': option.isDisabled,
            'cursor-pointer': !option.isDisabled,
          })}
        >
          <CheckboxComponent
            isChecked={option.isChecked || false}
            onChange={(_, e) => onChange(e)}
            label={option.label}
            isDisabled={option.isDisabled}
            value={option.value}
            labelClassName={cx({
              'text-maroon-400': option.isChecked,
              'hover:text-maroon-500': !option.isDisabled,
            })}
            className="p-2"
          />
        </div>
      ))}
    </div>
  )
}

export default CheckboxGroup
